import styled from 'styled-components';

type Props = {
  color: string;
};

export const ContainerStatus = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-top: 20px;
  width: 100%;
  max-width: 480px;
  margin: 0 auto 24px auto;

  @media (max-width: 650px) {
    text-align: center;
    align-items: center;
  }

  p {
    margin-top: 16px;
  }

  p + p {
    margin-top: 16px;
  }
`;

export const HeaderStatus = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;

export const WrapperIcon = styled.div`
  display: flex;
  align-items: center;

  svg {
    margin-right: 24px;
    flex-shrink: 0;
  }

  @media (max-width: 650px) {
    flex-direction: column;
    align-items: center;
    svg {
      margin-right: 0;
    }
  }
`;

export const TitleStatus = styled.h1<Props>`
  color: ${props => props.color};
  font-size: 20px;
  font-weight: bold;
  margin: 0;
  text-align: left;

  @media (max-width: 650px) {
    font-size: 18px;
    text-align: center;
  }
`;
